__turbopack_context__.v({
  "body": "UILink-module-scss-module__ChAG6W__body",
  "icon": "UILink-module-scss-module__ChAG6W__icon",
  "large": "UILink-module-scss-module__ChAG6W__large",
  "link": "UILink-module-scss-module__ChAG6W__link",
  "medium": "UILink-module-scss-module__ChAG6W__medium",
  "small": "UILink-module-scss-module__ChAG6W__small",
  "subhead": "UILink-module-scss-module__ChAG6W__subhead",
});
